/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import uid from './utils/uid.js';
import { defaultSpotProps, defaultTooltipStyle } from './constant.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var baseProps = {
  width: {
    type: Number,
    "default": 200
  },
  height: {
    type: Number,
    "default": 60
  }
};
var childProps = {
  data: {
    type: Array
  },
  limit: {
    type: Number,
    "default": 3
  },
  margin: {
    type: Number,
    "default": 3
  },
  styles: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  max: Number,
  min: Number
};
var spotPartProps = {
  points: Array,
  hasSpot: Boolean,
  spotlight: {
    type: [Number, Boolean],
    "default": false
  },
  spotStyles: {
    type: Object,
    "default": function _default() {
      return {
        strokeOpacity: 0,
        fillOpacity: 0
      };
    }
  },
  spotProps: {
    type: Object,
    "default": function _default() {
      return defaultSpotProps;
    }
  }
};
var refLinePartProps = {
  points: Array,
  refLineType: {
    type: [String, Boolean],
    "default": "mean"
  },
  refLineStyles: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  refLineProps: {
    type: Object
  }
};
var textProps = {
  point: Object,
  margin: {
    type: Number,
    "default": 2
  },
  textStyles: {
    type: Object,
    "default": function _default() {
      return {
        fontSize: 12
      };
    }
  },
  text: {
    type: String,
    "default": ""
  }
};
var sparklineProps = _objectSpread(_objectSpread({}, baseProps), {}, {
  preserveAspectRatio: {
    type: String,
    "default": "none"
  },
  margin: {
    type: Number,
    "default": 2
  },
  styles: {
    type: Object,
    "default": function _default() {
      return {};
    }
  },
  indicatorStyles: {
    type: [Object, Boolean],
    "default": function _default() {
      return {
        stroke: "#dd2c00"
      };
    }
  },
  tooltipProps: {
    type: Object
  },
  tooltipStyles: {
    type: Object,
    "default": function _default() {
      return defaultTooltipStyle;
    }
  },
  tooltipDelay: {
    type: Number,
    "default": 0
  }
});
var pieProps = _objectSpread(_objectSpread({}, sparklineProps), {}, {
  data: {
    type: Array
  },
  align: {
    type: String,
    "default": "left"
  }
});
var refLineProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseProps), childProps), spotPartProps), refLinePartProps), textProps), {}, {
  divisor: {
    type: Number,
    "default": 0.5
  }
});
var spotProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseProps), childProps), spotPartProps), refLinePartProps), textProps), {}, {
  divisor: {
    type: Number,
    "default": 0.5
  }
});
var lineProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseProps), childProps), spotPartProps), refLinePartProps), textProps);
var barProps = _objectSpread(_objectSpread(_objectSpread({}, baseProps), childProps), refLinePartProps);
var curveProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseProps), childProps), spotPartProps), refLinePartProps), textProps), {}, {
  divisor: {
    type: Number,
    "default": 0.5
  }
});
var gradientProps = {
  gradient: {
    type: Array
  },
  id: {
    type: String,
    "default": uid()
  }
};

export { barProps, curveProps, gradientProps, lineProps, pieProps, refLineProps, sparklineProps, spotProps, textProps };
//# sourceMappingURL=props.js.map
